import Image, { ImageProps } from 'next/image'

import { appStoreIcon, googlePlayIcon } from '@ui/assets'
import { APP_STORE_RATING, GOOGLE_PLAY_RATING } from '@ui/constants'

const StoreRating = ({
  icon,
  store,
  rating,
  reviews,
}: {
  icon: ImageProps['src']
  store: string
  rating: string
  reviews: string
}) => (
  <div className="flex items-center gap-2">
    <Image src={icon} width={22} height={22} alt="" className="rounded-full" />
    <p className="whitespace-nowrap text-base text-[#0a2d4a]">
      <span className="font-semibold">
        {rating} on {store}
      </span>{' '}
      <span className="hidden lg:inline">{reviews} reviews</span>
    </p>
  </div>
)

export const StoreRatingsPill = () => (
  <div className="inline-flex items-center gap-5 rounded-full border border-[rgba(10,45,74,0.1)] px-5 py-3">
    <StoreRating icon={appStoreIcon} store="App Store" {...APP_STORE_RATING} />
    <div className="h-5 w-px bg-[rgba(10,45,74,0.1)]" />
    <StoreRating
      icon={googlePlayIcon}
      store="Google Play"
      {...GOOGLE_PLAY_RATING}
    />
  </div>
)
